module.exports = __webpack_public_path__ + "img/transitos-Inter-2026.6130a3f6.png";